import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { statisticsKeys } from "./keys.ts";
import { getAssignmentStatistics } from "../api.ts";
import type { AssignmentStatistic } from "../../types.ts";

export const useAssignmentStatisticsQuery = (
  fromDate?: string,
  toDate?: string,
) => {
  return useQuery<AssignmentStatistic[]>({
    queryKey: statisticsKeys.assignment(fromDate, toDate),
    queryFn: async () => {
      const { data } = await getAssignmentStatistics(fromDate, toDate);
      return data.data;
    },
    ...reactQueryCacheAndRefetchOptions,
  });
};
